document.addEventListener('DOMContentLoaded', function() {
  var vqbLoaded = false;

  function loadQuiz() {
    if (vqbLoaded) return;
    vqbLoaded = true;

    var iframe = document.querySelector('.whai-embed');
    if (iframe && iframe.dataset.src) {
      iframe.src = iframe.dataset.src;
    }

    var script = document.createElement('script');
    script.src = 'https://cdn.visualquizbuilder.com/quiz/production/script_tag.js';
    document.head.appendChild(script);
  }

  function openModal() {
    document.querySelector('.popup-modal__overlay').style.display = 'flex';
    loadQuiz();
  }

  function closeModal() {
    document.querySelector('.popup-modal__overlay').style.display = 'none';
  }

  var trigger = document.getElementById('find_support_ipad');
  if (trigger) {
    trigger.addEventListener('click', function(event) {
      event.preventDefault();
      openModal();
    });
  }

  document.querySelector('.popup-modal__close').addEventListener('click', closeModal);

  document.querySelector('.popup-modal__overlay').addEventListener('click', function(event) {
    var modalContent = document.querySelector('.popup-modal__outer');
    if (!modalContent.contains(event.target)) {
      closeModal();
    }
  });
});
